import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "position-relative d-flex"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_link = _resolveComponent("g-link");
    return (_ctx.options?.caption)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.options?.infoLink)
                ? (_openBlock(), _createBlock(_component_g_link, {
                    key: 0,
                    target: "modal",
                    src: _ctx.options?.infoLink,
                    class: _normalizeClass(_ctx.options?.cssClass)
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.options?.caption), 1),
                        (_ctx.options?.infoLink)
                            ? (_openBlock(), _createBlock(_component_g_icon, {
                                key: 0,
                                src: "/assets/icons/info-square.svg",
                                class: "ms-1"
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["src", "class"]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(_ctx.options?.cssClass)
                }, _toDisplayString(_ctx.options?.caption), 3))
        ]))
        : _createCommentVNode("", true);
}
